import type { AllRouteEndpoints } from "../routeTypes";

export const deltashares = "/databricks_deltashares/:app_group_id";

export const deleteDeltasharesCacheKeys: AllRouteEndpoints[] = [deltashares];
export const postDeltasharesCacheKeys: AllRouteEndpoints[] = [deltashares];
export const putDeltasharesCacheKeys: AllRouteEndpoints[] = [deltashares];
